// Get all Patient Social History Status list

// PatientSocialHistoryControllerApi  getPatientSocialHistory

import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { PatientSocialHistoryControllerApi } from "../../../services";
import { getConfigObject, useBaseContent } from "../../../utils/utils";

interface Props {
  patientUuid: string;
  xTENANTID: string;
}

/**
 *
 * @author Atish Bagate
 *
 */
export const useGetAllPatientSocialHistoryStatus = ({
  patientUuid,
  xTENANTID,
}: Props): useBaseContent<any> => {
  return useQuery({
    queryKey: ["all-patient-social-history-status", patientUuid, xTENANTID],
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    enabled: !!patientUuid && !!xTENANTID,
    queryFn: async () =>
      await new PatientSocialHistoryControllerApi(getConfigObject())
        .getPatientSocialHistoryStatus(patientUuid, xTENANTID)
        .then((res) => res?.data),
  });
};
